import { render } from "./TranscriptPreview.vue?vue&type=template&id=8fdfc208&scoped=true"
import script from "./TranscriptPreview.vue?vue&type=script&lang=js"
export * from "./TranscriptPreview.vue?vue&type=script&lang=js"

import "./TranscriptPreview.vue?vue&type=style&index=0&id=8fdfc208&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fdfc208"]])

export default __exports__